import React, { useState } from 'react';
import { declineGuestAccountMerge } from '../../services/guestAccountLinkingService';
import Button from '../common/Button';
import { Modal, ModalContent } from '../common';
import { Card } from '../common/Card';
import { Heading, Text } from '../common/Typography';

const GuestAccountDeclineModal = ({ guestId, userId, guestName, onClose, onDeclineComplete }) => {
  const [declining, setDeclining] = useState(false);
  const [error, setError] = useState(null);

  const handleDecline = async () => {
    try {
      setDeclining(true);
      setError(null);
      await declineGuestAccountMerge(guestId, userId);
      onDeclineComplete?.();
      onClose();
    } catch (err) {
      console.error('Error declining merge:', err);
      setError(err.message || 'Failed to decline merge');
    } finally {
      setDeclining(false);
    }
  };

  return (
    <Modal isOpen onClose={onClose} closeOnBackdropClick={!declining}>
      <ModalContent size="small" constrainHeight={false}>
        <Heading level={3} className="mb-4 text-lg">
          Not your guest account?
        </Heading>

        {error ? (
          <Card variant="danger" size="small" className="mb-4">
            <Text className="text-sm text-danger">{error}</Text>
          </Card>
        ) : null}

        <div className="mb-6 space-y-4">
          <Text className="text-sm text-text-secondary">
            Dismiss linking for <span className="font-medium text-text-primary">{guestName}</span>? Your game history
            from that guest profile will stay separate.
          </Text>
          <div className="rounded-lg border border-warning/30 bg-warning-light/80 p-3">
            <p className="text-xs leading-relaxed text-warning-dark">
              You can reconsider this merge anytime from Player Hub under declined accounts.
            </p>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:gap-3">
          <Button variant="outline" onClick={onClose} disabled={declining} className="flex-1">
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDecline} disabled={declining} className="flex-1">
            {declining ? 'Dismissing…' : 'Dismiss'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default GuestAccountDeclineModal;
